import { colorsDark } from '../../themes';
import { opacity } from '../../utils';

export const popoverDarkTheme = {
  arrow: {
    size: '16px',
    shadowColor: opacity(colorsDark.gray[900], 40),
  },
  error: {
    padding: '8px 15px',
  },
  helper: {
    padding: '20px 25px',
    paddingRight: '50px',
  },
  backgroundColor: {
    info: colorsDark.gray[0],
    primary: colorsDark.blue[500],
    warn: colorsDark.orange[500],
    danger: colorsDark.red[700],
  },
  position: {
    default: 0,
    tooltip: '10px',
  },
  textColor: {
    info: colorsDark.gray[900],
    default: colorsDark.gray[0],
  },
};
